import { RoleId } from '@wix/members-domain-ts';

import SM_PRIVACY_STATUS from '../../constants/site-member-privacy-status';

export const findMemberNameByUid = (state, uid) => getMember(state, uid).name;

export const getMembersMap = (state) => state.members.map;
export const findMemberByUid = (state, uid) => getMembersMap(state)[uid];

export const getCurrentMemberId = (state) => state.members.currentMemberId;
export const getViewedMemberId = (state) => state.members.viewedMemberId;

export const getMember = (state, uid) => state.members.map[uid];
export const getCurrentMember = (state) => state.members.map[getCurrentMemberId(state)] ?? null;
export const getViewedMember = (state) => state.members && state.members.map[getViewedMemberId(state)];

export const isOwnProfile = (state) => getViewedMember(state) === getCurrentMember(state);
export const isViewedMemberLoading = (state) => state.members.viewedMemberLoading;

export const isMemberInCommunity = (member) => member && member.privacyStatus !== SM_PRIVACY_STATUS.PRIVATE;
export const inCommunity = (state) => isMemberInCommunity(getViewedMember(state)); // TODO: rename

export const memberHasEditRoleAction = (member) =>
  member && member.rolesActions && member.rolesActions.filter((role) => role.roleId === RoleId.EDIT).length > 0;
export const canEditViewedMember = (state) => !!memberHasEditRoleAction(getViewedMember(state));

export const isBlocked = (state, uid) => {
  const viewed = findMemberByUid(state, uid);
  return !!viewed && !!viewed.roles && viewed.roles.indexOf(RoleId.BLOCK_MEMBER) >= 0;
};

const canSeeBlockedMembers = (roles) => {
  const rolesWithAccess = [RoleId.ADMIN, RoleId.SET_FORUM_MODERATOR];
  return rolesWithAccess.some((roleWithAccess) => roles.includes(roleWithAccess));
};

export const showAsBlocked = (state, uid, shouldHideSuspendedLabelForNonOwners = false) => {
  if (shouldHideSuspendedLabelForNonOwners) {
    const currentMember = getCurrentMember(state);
    return currentMember?.uid !== uid && isBlocked(state, uid) && canSeeBlockedMembers(currentMember?.roles ?? []);
  }
  const currentId = getCurrentMemberId(state);
  return currentId !== uid && isBlocked(state, uid);
};

export const getViewedMemberBlocked = (state, uid, useViewedMemberBlocked = false) => {
  if (useViewedMemberBlocked) {
    const currentId = getCurrentMemberId(state);
    return currentId !== uid && isBlocked(state, uid);
  }
  return false;
};

export const getViewedMemberStats = (state) => getViewedMember(state).stats || {};

export const getMemberSlug = (state, uid) => (getMember(state, uid) || {}).slug;
